import maintainRequest from "@/maintain/utils/maintainRequest";

export default function addGroup(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/addGroup`,
    method: "post",
    data,
  });
}
